import { mat4, ReadonlyMat4, ReadonlyVec3, vec3 } from 'gl-matrix';
import {
    DeformableTransform,
    mapPointBackThroughDeformation,
    mapPointThroughDeformation,
} from '~/domain/dvf/deformableTransform';

export interface FrameTransform {
    readonly forward: (pointMm: ReadonlyVec3) => vec3 | undefined;
    readonly backward: (pointMm: ReadonlyVec3) => vec3 | undefined;
}

export function rigidFrameTransform(
    fixedToMoving: ReadonlyMat4
): FrameTransform {
    const movingToFixed = mat4.invert(mat4.create(), fixedToMoving);
    return {
        forward: (pointMm) =>
            vec3.transformMat4(vec3.create(), pointMm, fixedToMoving),
        backward: (pointMm) =>
            movingToFixed
                ? vec3.transformMat4(vec3.create(), pointMm, movingToFixed)
                : undefined,
    };
}

export function deformableFrameTransform(
    transform: DeformableTransform
): FrameTransform {
    return {
        forward: (pointMm) => mapPointThroughDeformation(transform, pointMm),
        backward: (pointMm) =>
            mapPointBackThroughDeformation(transform, pointMm),
    };
}
